<template>
    <div class="story-page">
    <div class="header2">
        <nav class="chapter-navigation" 
        :class="{ 'mobile-nav-visible': isMenuVisible }">
          <button @click="toggleMenu" class="close-button">
            &times;
          </button>
          <ul class="quick-links">
            <li v-for="(chapter, index) in chapters" :key="index" :class="{ 'disabled-link': !chapter.isAvailable }">
              <a v-if="chapter.isAvailable" :href="'#' + chapter.id" @click.prevent="scrollToChapter(chapter.id)" style="text-align:center">
                Chapter {{ chapter.chapterNumber }}: {{ chapter.title }}
              </a>
              <span v-else>
                Chapter {{ chapter.chapterNumber }}: {{ chapter.title }} - - Coming Soon
              </span>
              <!--
              <div v-if="chapter.isAvailable" class="rating-buttons">
                <button @click="rateChapter(chapter.id, 'up')" class="thumbs-up">👍</button>
                <button @click="rateChapter(chapter.id, 'down')" class="thumbs-down">👎</button>
              </div>-->
            </li>
          </ul>
        </nav>  
    </div>


    <header class="story-header">
      <div class="header-container">
        <h1 style="text-align:center;">{{ storyTitle }}</h1>
        <button @click="toggleMenu" class="hamburger-button">
          ☰
        </button>
      </div>
    </header>

    <main class="story-content">
      <section v-for="(chapter, index) in chapters" :key="index" :id="chapter.id" class="chapter-section">
        <h2 v-if="chapter.isAvailable">Chapter {{ chapter.chapterNumber }}: {{ chapter.title }}</h2>
        <div v-if="chapter.isAvailable" class="chapter-text" v-html="chapter.content"></div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'StoryView',
  data() {
    return {
      storyTitle: 'Northern Skies',
      chapters: [
        {
          id: 'chapter-1',
          chapterNumber: 1,
          title: `Hard Knocks at the Hard ROCs`,
          content: `
<p style="text-indent: 50px">
It was late on a Friday when Adam Borealis walked into the bar, <i>Hard ROCS</i>.  The bar was located in the middle of town, 
but he wasn't expecting much.  It was the same routine this Friday night as last.  His friends abandoned him to be with
girls, leaving him high and dry on a payday weekend.  Adam had been to <i>Hard ROCS</i> before, after all, this was the only 
bar that served his favorite drink to end nights like this, Hurricane Cat 5.</p>
<p style="text-indent: 50px">
    Adam entered the establishment and took a seat at the bar, not paying much attention to anyone else.
“Make it a double tonight, Jon.”  Adam said to the bartender with a low growl.  Jon Deamok nodded and hopped to it.  
Adam set his phone on the table and took a deep breath.  It was an exhausting day, and Adam felt he deserved a little R&R.  
After his drinks were set in front of him, he started to scroll through his phone for places to go after this.</p>
<p style="text-indent: 50px">
    The underground challenge arena across town, where contestants were randomly selected from the crowd and pitted against 
    each other in hand-to-hand combat, was always exciting.  Adam was a pretty good fighter, but he scrolled past the post.  
    There was always some kind of nightly parade going on down on main street.  The spectators would vote on who looked the
    strongest, or who they thought was the smartest, or who had the most charisma.  The thought made him laugh.  
    Adam was voted first in some of the parades, when he accidentally stumbled upon them after some drinks.  The Lover's Garden 
    had plenty of men and women open to romance for anyone with the right money.  None of the listings appealed to Adam, though.  
    Seeing the advertisement for the Lover’s Garden only reminded Adam of how giddy his friends were, talking about their girlfriends.  
    He shook his head in disappointment.  Adam still hadn't met anyone that sparked his interest.  When he set down his phone, 
    he caught a glimpse of an enchanting beauty sitting across the bar.  He blinked his eyes a few times, trying to make sure 
    she was real and not some dreamed up imaginary figure of an ethereal fairy.  She was too beautiful to be in this bar with him.  
    Adam was rendered speechless.
</p>
<p style="text-indent: 50px">
Across the bar, Aurorah Olafdottir drummed her fingers on the bar.  The only thing Deamok offered her was a glass of water.  
She wasn’t some young girl who accidentally wandered into <i>Hard ROCS</i>.  She was a fierce independent woman, who knew 
exactly what she wanted, and that was a drink!  All night, Aurorah was politely trying to get the attention of the bartender, 
but admittedly, the place was packed.  The <i>Hard ROCS</i> was the most popular bar, and it was as if the whole town had shown 
up, Aurorah thought.
</p>
<p style="text-indent: 50px">
Just as she managed to make eye contact with the bartender, some big brute of a man walked in and ordered a double. She noticed 
Deamok quickly turned and greeted the stranger, starting on his order right away.  The nerve, Aurorah fumed to herself.  Instead 
of serving her, who had been patiently waiting, the bartender scrambled over to serve the man.  Whether he was a usual customer or 
not, it was rude.  She had been waiting for what felt like AGES now!  Aurorah looked around the bar, trying to find where her friend 
Medusa had snuck off to.
</p>
<p style="text-indent: 50px">
It was Aurorah’s birthday and her best friend, Medusa Magia had to pick this stupid bar to celebrate.  Everything about it annoyed 
her.  Aurorah didn't even like going out to loud places to celebrate, and this bar was so loud!  She liked her space, her little 
home with her dogs, and she liked the moments of peace that came with the wind whistling on her ears as she ran with her dogs 
in the early mornings, during sunrise.  Those were the moments she cherished, not this.  This was the exact opposite.
</p>
<p style="text-indent: 50px">
Tonight was an endless war with people shouting, laughing, and horsing around.  Her head was pounding, only fueling her irritation.  
Tonight was not the ‘good time’ she was promised by Medusa.  Instead of enjoying her birthday in peace, she was stuck here, late 
at night in a bustling bar, in the center of town.  The icing on this proverbial cake was the rude brute of a man, who just cut 
in front of her at the bar.  She couldn’t hold herself back anymore.
</p>
<p style="text-indent: 50px">
Knocking back her glass of water like it was a shot, Aurorah glared at the man, who was staring at his phone.  She was furious!  
When he looked up at her, she made sure her gaze pierced him with pure, undiluted anger and frustration.  She wasn’t going to let 
him get away with it.  She would have her birthday fun.
</p>
<p style="text-indent: 50px">
“HEY!”  Aurorah hollered at the man across the bar.  She slammed her water glass back down on the bar, causing Deamok to flinch.  
Adam gazed back at Aurorah, looking baffled.  “Can’t you see there are others waiting for a drink!?  You aren’t the mayor of 
Niveal or anything!”  She blurted out before she could stop herself.  Adam sat up, taking in the scene before him.  
His eyes roved from her empty cup, up her arm, to her flushed flawless skin of her cheeks.  Her icy blue eyes held an intensity 
he had never seen before.  She was gorgeous!
</p>
<p style="text-indent: 50px">
“Sorry ma’am.  What can I get you?”  The bartender asked Aurorah, but she wasn’t paying attention to him.  Her eyes are fixed on 
the dumbfounded man who cut in front of her.  He was a moron, Aurorah thought to herself, but now that she saw his face, she had 
to admit he was a handsome moron.  She shook the thoughts out of her head.
</p>
<p style="text-indent: 50px">
“Are you stupid or something?”  Aurorah yelled, holding her hand to the man.  “Ladies should always be served first!”
</p>
<p style="text-indent: 50px">
Adam gave his head a shake to break the trance he was stuck in.  He watched as Aurorah finally placed her order with Deamok.  
“Sorry!  Please forgive me, my lady.”  Adam admitted sheepishly.  “I didn't realize I was cutting in front of an angel.”  
He said with a smile.
</p>
<p style="text-indent: 50px">
Aurorah lifted an eyebrow in his direction.  First, he was rude.  Now, this brute had the nerve to hit on her.  His cheesy pickup 
lines were not going to work on her. She huffed and accepted her drink, thanking Deamok.  All she wanted was to enjoy a beer with 
Medusa for her birthday.  It was Medusa’s idea to come to <i>Hard ROCS</i> and celebrate with drinks.  It was Medusa who convinced 
her to leave her cozy, quiet little house.  Where the hell was Medusa?!  Not only had she lost her friend in the crowd, but now she 
was being hit on by some cavalier stranger.  Aurorah wasn’t standing for it.  It only added fuel to her fury.  She had the sharpest 
wit in all of Niveal, and she would make sure this man knew it.
</p>
<p style="text-indent: 50px">
“Are you saying I look dead inside?  That I’m merely some spirit figure whaling for my drink as I enter the afterlife?”  Aurorah 
snapped back at Adam.  He sat straighter in his chair and offered her a sly smile.  This was only the beginning of a very interesting 
night for him.
</p>
<p style="text-indent: 50px">
“Quite the opposite, actually.  You knocked me dead with those looks, beautiful.”  Adam responded brazenly.  His first drink was done, 
and he was starting on his second.  Adam relaxed in his seat and leaned on the bar, enjoying himself for once.  The unusual company 
was a welcomed surprise in his life.  “What’s your name?”  Adam asked.  He had never met anyone like her before.
</p>
<p style="text-indent: 50px">
Aurorah huffed out a laugh.  Some of her anger was soothed by his surprisingly brave attitude.  “Like I would tell you.”  She drank 
her beer and closed her eyes.  Aurorah was proud, but she wasn’t too proud to admit he was funny.  His shoulders were broad, and he 
had definition that heated her blood.  Instead of being repulsed by her out right rejection of his advances, the man seemed 
persistent, curious even.  That amused her.  He smiled at her from across the bar, patiently waiting for her to share her name.  This 
was new for Aurorah.  She never let men get close to her, and she wasn’t shy about establishing boundaries.  If he wanted anything 
from her, he had to surrender first.  “Why would I tell you my name when you haven’t introduced yourself yet.”  Aurorah said after 
taking another gulp of her beer.  “You could be a murderer.”  Deamok was quick to refill her glass.
</p>
<p style="text-indent: 50px">
“How rude of me.”  Adam apologized with a chuckle.  “My name is Adam Borealis.  It’s truly a pleasure to meet you.”  He said and 
genuinely meant it.  “The only thing I’m guilty of is falling for your beauty.”
</p>
<p style="text-indent: 50px">
“It would be your pleasure.”  Aurorah sighed, hiding her smile.  She was finally enjoying herself.  “It certainly hasn’t been mine.”  
She scoffed.
</p>
<p style="text-indent: 50px">
“I can help fix that if you let me.”  Adam remarked quickly.  “That way, we can both have a fun night.”  His playful teasing 
solicited another smile from Aurorah before she quickly banished it away.  It must be the beer, she thought.  She was angry, furious 
even!  Wasn’t she?  It was hard to recall those feelings now, but she wasn't about to let Adam get the best of her.  Aurorah shrugged 
her shoulders.
</p>
<p style="text-indent: 50px">
“Do you think I’m that easy or something?  How insulting.”  Aurorah replied.
</p>
<p style="text-indent: 50px">
“I think you're gorgeous.”  Adam answered.  “And you have a very sharp wit.”  He sipped his drink without taking his eyes off Aurorah.
He was afraid that if he did, she would disappear.  Adam didn't want that.  He enjoyed chipping away at the ice barrier surrounding 
this Icelandic goddess.  “Do you come around here often?  I don’t think I’ve seen you around before.”  Adam tipped his glass to her.  
“I would definitely have remembered.”
</p>
<p style="text-indent: 50px">
“AURORAH!”  Someone shouted from behind.  Aurorah blanched and turned in her seat.  Medusa jogged up to her, sweaty and laughing.  
“Hey, some of my other friends have a table over there.”  Medusa said, pointing toward the center of the bar.  Aurorah cringed at 
the thought.  That’s the last place she wanted to be.  “If you want, I can have them kick someone to make room for you?”
</p>
<p style="text-indent: 50px">
“Aurorah.”  Adam muttered with a hum.  “What a truly lovely name for a lovely lady.”  Medusa and Aurorah both glance at Adam.
</p>
<p style="text-indent: 50px">
“Who’s the bum?”  Medusa whispered to Aurorah.  Aurorah took a deep breath and rubbed her forehead.  Two choices were laid out before 
her.  She could choose to stay at the bar with Adam, trading quick quips with each other, or sit at the loud table in the middle of 
the bar with Medusa and her friends, negotiating the rest of the evening away on how to celebrate her birthday.
</p>
<p style="text-indent: 50px">
“I’m good, thanks.”  Aurorah finally said, glancing at her glass.  She made her choice.  “I think the beer is giving me a headache.  
I’ll stay here where it isn’t so loud.”  She answered her friend.  Medusa rubbed Aurorah’s back.  Medusa wanted Aurorah to enjoy her 
evening.  This was her friend's birthday, a night for celebrating!  She glared at Adam.  The last thing Medusa wanted was to abandon 
her friend with some vulture circling.  That wasn’t the Fenix way!
</p>
<p style="text-indent: 50px">
“If you say so.  Sorry that your-,” Medusa started before Aurorah slapped her hand over Medusa’s mouth.  The last thing Aurorah 
wanted was for Adam to learn it was her birthday.  She wasn’t sure where things stood between them, if they stood at all, and this 
news would only muddy the waters.
</p>
<p style="text-indent: 50px">
“We’ll talk about it later.”  Aurorah hissed.  “Now, go!  Go wish everyone hello on my behalf.”  Medusa nodded and glanced at Adam.  
He was still watching the pair of ladies in quiet amusement.  This was the first Friday night, in a long list of Fridays, that he was 
actually enjoying himself.  Medusa sized up Adam, debating whether she should force Aurorah to come with her or not.  It was her idea 
to come to the bar after all, and she would feel guilty if Aurorah didn't have a good time.  This was supposed to be fun for both of 
them, not just her.
</p>
<p style="text-indent: 50px">
“Are you going to be alright?”  Medusa asked.  Her tone shifted to a more lethal one.  They might be ladies of the church, but that 
didn't mean they wouldn't throw hands if needed.  “I’ll keep an eye on you, just in case.”  Medusa whispered.  Aurorah smirked when 
she saw Adam react to the subtle threat.  They were ride-or-die friends, and Aurorah knew that Medusa meant what she said.
</p>
<p style="text-indent: 50px">
“Thanks, girly, but I’ll be fine.”  Aurorah said.  “See you later.”  Medusa nodded and dove back into the throng of bar patrons 
toward the tables where people were laughing and shouting.
</p>
<p style="text-indent: 50px">
“So, your name is Aurorah?”  Adam asked to be sure.
</p>
<p style="text-indent: 50px">
“What if it is?  That doesn't mean anything to you.”  Aurorah answered back coldly.  She couldn't stop the flood of heat from rushing 
to her face.  She chose to stay here, with this beast, instead of leaving with her friend.  What had gotten into her?  It must be the 
beer.
</p>
<p style="text-indent: 50px">
“It means I know what to write on the label when I send you flowers.”  Adam teased.
</p>
<p style="text-indent: 50px">
“Because you're going to kill me with your cheesy pickup lines?”  Aurorah snorted, drinking more of her beer.  “At least I can count 
on you being a gentleman and decorating my grave.”
</p>
<p style="text-indent: 50px">
“I can show you how much of a gentleman I really am.”  Adam chuckled, without missing a beat.  He enjoyed watching the rosy blush that 
kissed Aurorah’s cheeks before her frosty exterior cooled it off.  Adam grew more and more curious about Aurorah as the night went 
on.  Likewise, Aurorah wasn’t as upset with Adam as she originally had been.  His relentless flirting was growing on her.  The two 
went back and forth, trading quick and witty jabs, before Medusa came to collect her friend.  The bar was starting to quiet down as 
the night grew deeper.
</p>
<p style="text-indent: 50px">
“Come, Aurorah!”  Medusa giggled as she hooked her arm with Aurorah’s.  “It’s time to go.  We have duties tomorrow at the church.”  
She burped, forgetting that Adam was there.  Aurorah laughed.  She was feeling good after a few beers, especially after Adam 
volunteered to pick up her tab.  Aurorah nodded and closed her eyes.  They both worked at the Fenix Monastery, and it was their turn 
to take care of the shelter animals.  Aurorah loved taking care of the animals and never complained when it was her turn.  Everyone 
that worked at the Fenix Monastery took turns looking after the abandoned pets and stray animals of Niveal, caring for them until they 
could be adopted into their new forever home.  Aurorah was lost in her dreamy thoughts, that she forgot Adam was listening.
</p>
<p style="text-indent: 50px">
“The church?”  Adam cut in.  He thought about all the churches in the area.  There was only one that he could think of inside the 
city of Niveal, the Fenix Monastery.  “You both work at the Fenix Monastery that Jasminy runs?”  Adam asked.  Adam had heard of 
Jasminy Angeles before.  She was the fierce director of the Fenix Monastery, who defended her people and the facility against scrutiny 
from the citizens of Niveal.  The fighting wasn't always pretty, and some of the conflicts fueled the gossip about the church and 
those that worked there, including Jasminy.  Adam had heard his fair share from mumblings around bars and at his work.
</p>
<p style="text-indent: 50px">
The Fenix Monastery was large, and it had tons of resources that supported the city and its people.  There was a pet shelter, an 
infirmary, a chapel, and even an orphanage all contained on the monastery’s grounds.  Adam was always impressed by the gothic 
architecture of the buildings, but he never had a reason to venture inside… until now.  Adam would gladly pay a visit to Jasminy’s 
domain if it meant seeing Aurorah again.  He waited for them to answer his question, but neither of the women did.
</p>
<p style="text-indent: 50px">
“That’s none of your business.”  Medusa remarked, flicking her curly brown hair back.  “Come on, girl.  Let’s get back home, where 
we can continue the party with the others!”  Medusa gushed.  She pulled out her phone and smiled at the text notification.  
“Katia just wrapped up and is free to join our banquet.”  Adam nodded his head and offered Aurorah a wave as the ladies left the 
bar.
</p>
<p style="text-indent: 50px">
Katia Volkov was another name that was infamous in Niveal.  She also worked at Fenix Monastery as a sister of the church.  Just like 
Jasminy, Katia had a fearsome reputation.  When a motorcycle riding, cigar smoking Sister starts a fight in a bar, the whole of 
Niveal talks about it.  That was Katia Volkov.  If citizens didn't fear her, they admired her from a respectable distance.
</p>
<p style="text-indent: 50px">
“Phew.”  Deamok sighed as he sat across from Adam at the bar.  Adam lifted his eyebrow at the exhausted bartender.  “I thought I 
was done for.  Thank you for saving my ass.”  The bartender sank onto his stool and folded his arms on the bar top, plopping his 
head down to rest on them.  “Those women are scary.”
</p>
<p style="text-indent: 50px">
“What are you talking about?”  Adam asked.  Those women were the most interesting people in the whole bar in Adam’s opinion.  
“They weren't scary at all.”
</p>
<p style="text-indent: 50px">
“That’s because you don't know them like we do.”  Deamok said, peeking up at Adam.  He waved his hand to gesture to the bar.  “They 
are always here, giving <i>Hard ROCS</i> a hard time!”
</p>
<p style="text-indent: 50px">
“What?”  Adam had a hard time believing Deamok.  “I haven’t seen them here before, and why do you keep referring to them as they?”  
Adam had frequented the <i>Hard ROCS</i> plenty of times before.  He tapped his fingers on his glass as he thought about it.  
<i>Hard ROCS</i> was open all day, twenty-four hours, seven days a week.  While Adam considered himself a usual, he didn't visit the 
bar every day.
</p>
<p style="text-indent: 50px">
“They, being the Fenix Monastery folk!  They are always here stirring up trouble.  The minute they open their mouths in a public 
setting, shit comes out.  It’s drama for days!”  Deamok glanced at the tables in the middle of the room.  At least for tonight, no 
drama was started with the gym rats drinking at the tables.  “Those muscle heads over there are from the DNA gym.”  Deamok said, 
glancing at Adam.  “You know, Don’t Negotiate Anything Gym?”  He laughed.  Adam laughed with Deamok.
</p>
<p style="text-indent: 50px">
“You mean, Dumb Nutty Assholes.”  Adam mocked.  Most gyms in Niveal had that reputation.  People would get big heads about their 
gains and parade around like they were the best.  The members of Deadlifts N’ Abs Gym, or the DNA Gym, were no exception.  The leader 
of the gym went by “The Professor,” and made body building sound like a scientific study.  Diet and exercise encompassed their whole 
life.  Naturally, their pretentious judgmental ways earned them the honorary title of most hated institute in all of Niveal.  The 
director of the gym never responded to complaints, either.  Nobody ever saw the Professor out in public, and Adam recalled all the 
jokes he heard about them.  When he glanced over at the table, his eyes found the prima donna of the group, Mercedes Lopez.  Adam 
rolled his eyes.
</p>
<p style="text-indent: 50px">
“Dude, you have no idea how much drama could have erupted tonight.”  Deamok sighed.  He sat up and grabbed a glass for himself.  
“Those DNA dorks always start drama with the FNX girls.”  He glanced at Adam.  “That’s what we call the Fenix Monastery, FNX.”  Adam 
scratched the stubble on his chin.
</p>
<p style="text-indent: 50px">
“Tell me about FNX.”  Adam said, ordering another Hurricane Cat 5.  His interested was piqued, and he wanted to know more about 
Aurorah.  He needed to know.  Deamok happily obliged.
</p>
<p style="text-indent: 50px">
“Well, I’m sure you heard of Jasminy Angeles, right?  That crazy dictator of FNX?”  Deamok laughed.  He tipped his glass in Mercedes 
direction.  “I guess there was some fighting between the high school girls in the orphanage and high school members of the DNA gym.  
Ever since then, the two factions bicker and talk shit to each other everywhere they meet.”  Adam pursed his lips.  That was not what 
he just witnessed.  Medusa and Aurorah seemed like regular girls that came to the bar to have a good time.  Adam didn't see who 
Medusa spent the night with, but she didn't cause any kind of scene like what Deamok was describing.
</p>
<p style="text-indent: 50px">
He titled his head as he listened to Deamok continue.  Nothing he heard made sense.  Aurorah was snappy with him, but he didn't feel 
it was because she was being a bitch.  Adam noticed she was rubbing her head and wincing when others would roar with laughter.  He 
wondered if Deamok noticed.  What he was hearing didn't sit right with Adam.  From the comments about the women, to the rumors about 
FNX, nothing sounded true.
</p>
<p style="text-indent: 50px">
“Are you sure?”  Adam interrupted.  “I’ve seen Miss Perfect over there cause drama in the bar.  I’ve never seen Aurorah or friend 
cause trouble.”  Deamok sat up.  His face flushed with color.
</p>
<p style="text-indent: 50px">
“Well… I’ve never seen anything myself.  I just work here.”  Deamok said.  He casually shrugged his shoulders and went back to tending
the bar.  “But I would stay away from FNX if I were you.”  Adam waved the bartender’s concern aside.  He didn't need anyone telling 
him what to do.  When he finished his drink, Adam checked his phone.  He was never able to ask Aurorah for her number.  He had to 
make up for it.
</p>
<p style="text-indent: 50px">
“Aurorah…”  Adam said as he paid and headed home.  “So you’ve been hiding away in FNX.”  Adam muttered to himself.  He started to 
chuckle as he stepped out the bar.  “At least I know what to write on the card when I pick up the flowers tomorrow.”
</p>`,
          isAvailable: true, // Set to false to hide it
        },
        {
          id: 'chapter-2',
          chapterNumber: 2,
          title: 'Keeping an EYE on Things',
          content: `
            <p style="text-indent: 50px">“Hi!  Welcome to the Fenix Monastery.”  Said the bubbly teenager who 
was sitting at the front desk.  She looked about seventeen, Adam guessed, maybe eighteen.  Her bright 
blue eyes went right to the bouquet of flowers in his hand.  The young girl bit her bottom lip in excitement.  
“You brought flowers for someone?  Who!?”  She gasped. </p>
<p style="text-indent: 50px">
“Flowers for someone?”  Whispered a quiet voice before Adam could answer.  He glanced to the right and saw 
another teenager.  She looked younger, about fifteen, with long blonde hair down to the floor.  She blinked up 
at him innocently.  “Are they not to decorate the altar for church?”  The young maiden placed her hands to the 
wall, clinging to the corner of the hallway.  She was ready to escape into the monastery at the first sign of 
danger. </p>
<p style="text-indent: 50px">
“Oh, it's way too small to be for the altar.”  Said the teenager behind the desk.  She brushed some of her 
auburn hair behind her ear.  “Father Zephyr always orders much larger arrangements than that.”  After clearing 
her throat, the girl introduced herself.  “I am Allyson Woodrain.  It’s nice to me you!”  She said, bowing her 
head to Adam.</p>
<p style="text-indent: 50px">
“Oh,”  Adam responded.  He was caught off guard by the children.  Nowhere else in the city had children running 
the reception desk.  It was dangerous!  What was Jasminy thinking leaving them in charge, Adam pondered.  Adam 
glanced at the shy one hiding behind the entryway to a hallway on the right.  “Hi.  My name is Adam Borealis.  
It’s nice to me you.”  He said awkwardly.  Allyson came out from behind the desk with a tablet in her hand. </p>
<p style="text-indent: 50px">
“That’s Rapunzel Grimm.  She’s my assistant and helps me out at the front desk sometimes.”  Allyson said, 
holding the tablet out to Adam.  She held her other arm out for the bouquet of flowers.  “I can take the 
flowers while you sign in.”  Allyson said, nudging the tablet to Adam. </p>
<p style="text-indent: 50px">
“Sign in?  What is with all the protocol?”  Adam asked confused.  This was a monastery, not a prison!  
Rapunzel nodded and walked over. </p>
<p style="text-indent: 50px">
“I can hold the flowers.”  Rapunzel said, holding out her arms.  “Are they for Jas?”  The girls giggled 
together.  Lots of people dropped by to bring flowers for Jasminy. </p>
<p style="text-indent: 50px">
“We ask that all our visitors sign in so we can keep a record of why they were here.  It helps us with 
city funding and keeps track of people that come and go, just in case there are any problems.”  Allyson 
explained with ease.  Her nervous giggle at the end made Adam suspicious.  He wasn't sure what kind of 
problems there could be involving a monastery, but the conversation he had with Deamok played through 
his head.  FNX had a lot of enemies and a bad reputation around Niveal.  It was only natural that they 
maintain records to protect themselves.  It was then that Adam started to notice all the security around 
the front entrance and in the lobby. </p>
<p style="text-indent: 50px">
Adam handed the flowers to Rapunzel before taking the tablet from Allyson.  While he typed in his name 
and why he was here, he peeked around the room.  The lobby was large and welcoming.  There were glass 
panels next to the front door that let in a bounty of natural light.  There were matching indoor plants 
on either side of the sofas, with a small coffee table in between.  It looked cozy and welcoming for people 
that wanted to stop by for a quick chat.  Guarding the entrances to hallways on the left and the right was 
the front desk.  Adam spotted four cameras discreetly fixed on the ceiling, two spy microphones on the 
plants near the sofas, and an unusual black bar covering the hinges of the front door. </p>
<p style="text-indent: 50px">
“What sort of problems are you expecting?”  Adam asked, staring at the front door.  Allyson took the tablet 
back and checked over the information.  Adam had never seen such countermeasures in a monastery before. </p>
<p style="text-indent: 50px">
“There have been all kinds of problems around here.”  Allyson said, glancing over the information.  Adam
didn't want to list Aurorah’s name, so he wrote that he was here visiting a friend.  Allyson swiped left 
and entered the information to run a background check on Adam while they waited.  She didn't tell him what 
she was doing, but it was standard protocol that kept their organization safe from those that wished them 
harm.  After the background check started, Allyson held the tablet to her chest so that Adam wouldn’t see.  
“Sometimes people come here to work stuff out and then later claim we said this or that, were rude to them, 
or they claim we mistreated them.  It’s all lies to make us look bad.  The only defense against those kinds 
of attacks are photographs and voice recordings.”  Allyson explained.  Adam glanced at Allyson, who only 
smiled in response.  “I saw you mark our security system.  You must have military experience, right?”  Adam 
tensed in response. </p>
<p style="text-indent: 50px">
“Ha, ha!  I do.”  Adam admitted.  She might be a teenager, but he could tell Allyson was brilliant.  When he 
peeked over at her desk, he saw a dual monitor setup with code running in a terminal.  Adam had to be 
careful while he was here.  These people seemed nice, but they were no door mats!  Allyson was monitoring 
the desk because of the security she was running, Adam realized.  No wonder there were children running the 
lobby.  They weren’t in danger here, he was.  “I used to serve, but now I’m a-,” he started before the tablet 
chimed.  Allyson glanced down at it.  </p>
<p style="text-indent: 50px">
“Now you're a correctional officer at the Niveal Penitentiary!”  Allyson beamed.  She glanced up at Adam 
with a smile.  “Cool!  Law enforcement is a great role for ex-military.  Thank you for your service, Mr. 
Borealis.”  Adam was rendered speechless.  He was starting to wonder if coming here was a good idea or not.  
The flowers could have been delivered anonymously, sparing Adam all this awkward invasion of his privacy. </p>
<p style="text-indent: 50px">
“These flowers are for Aurorah!”  Rapunzel gasped.  Adam and Allyson both glanced at her.  “Are you and 
Aunty Aurorah dating!?”  Adam glanced from one girl to the other.  They were both staring at him with 
sparkling wonder struck eyes.  This was more than he was planning for.  He was curious about FNX, but he 
wasn't sure how deep he wanted to go just yet.  His mission was just to stop by on his day off and see if 
Aurorah was here.  Small talk and banter he prepared for.  Being background checked and scrutinized by FNX 
he was not! </p>
<p style="text-indent: 50px">
“Um… No.”  Adam responded, taking a step toward the door.  “Aurorah and I were just talking, and…” His face 
heated.  The girls were hanging on his every word.  He offered a friendly chuckle.  “And this was an inside 
joke.”  Adam gestured to the flowers.  That was all, he reminded himself.  Aurorah made it clear she 
respected actions, not words.  Telling her he would send her flowers was not the same as bringing her 
flowers. </p>
<p style="text-indent: 50px">
“No one’s ever brought us flowers.”  Rapunzel muttered quietly.  She glanced at Allyson with hopeful eyes.  
“Is he allowed in the garden with the pets?”  She asked.  That’s where Aurorah would be, and Rapunzel 
couldn’t wait to see Aurorah’s face.  Adam raised an eyebrow at the girls.  Allowed, he wondered.  That 
didn't seem normal. </p>
<p style="text-indent: 50px">
“Yes!”  Allyson squealed, bouncing on her heels.  She shuffled over to the front desk and hit a couple of 
buttons on the computer.  She set the tablet back in the charger and messaged Jasminy on their intranet work 
chat service.  The different facilities of Fenix Monastery stayed connected and in constant contact via their 
internal chat service.  Allyson opened up the chat box, and her fingers danced across the keys. </p>
<p style="text-indent: 50px">
<i>FrontDesk: Mother!  We have a guest here to see Aunt Aurorah!  He even brought her flowers!</i></p>
<p style="text-indent: 50px">
Allyson giggled when she saw the bouncing dots of others responding.  Rapunzel was asking Adam the basic 
questions like where did he meet Aurorah and what was the joke about the flowers.  Allyson glanced back at 
the screen to see everyone was excited about the guest. </p>
<p style="text-indent: 50px">
<i>KatiaTheGreat:  He?  The guest is a man?</p>
  <p style="text-indent: 50px">
YunnaKitty:  YAY!  Aunt Aurorah has a boyfriend! </p>
<p style="text-indent: 50px">
DocEdric:  Did you run the background check I installed on the tablet?  What did it say? </p>
<p style="text-indent: 50px">
MotherJas: Do not leave the front, Allyson!  I’m coming. </p>
<p style="text-indent: 50px">
KatiaTheGreat:  Is there anyone else with you at the front desk?  I saw Moriane walk by. </p>
<p style="text-indent: 50px">
FatherZeph:  I’m stepping out to get some cigarettes.  I’ll be back in 20mins. </p>
<p style="text-indent: 50px">
YunnaKitty: Can I meet him!? </p>
<p style="text-indent: 50px">
MotherJas:  NO!  I thought I took your phone away, Yunna!  You are sick!  Go to bed! </p>
<p style="text-indent: 50px">
DocEdric: Rapunzel might be with her.  I had to pull Moraine to help with patients. </p>
<p style="text-indent: 50px">
MotherJas: >___<  …. Why didn't you tell someone it was just Allyson and Rapunzel!? </p>
<p style="text-indent: 50px">
KatiaTheGreat:  I’m coming too.  Hang tight, Ally.  Don't let him inside until I get there. </p>
<p style="text-indent: 50px">
FrontDesk:  Roger that, Aunt Katia! </p></i>
<p style="text-indent: 50px">
Allyson shook her head as the chat continued.  Jasminy was warning the other children to stay away from 
the front desk while lecturing her brother Edric Angeles about taking Moraine away without letting her 
know.  Normally, Allyson worked the front desk with her older sister, Moraine Drachentoter. </p>
<p style="text-indent: 50px">
The orphanage on the monastery grounds housed a dozen orphans, which the staff of FNX all took care of as a 
village.  Jasminy provided for all the orphans in FNX and lovingly called them all her children.  That 
made Allyson and Moraine sisters, along with all the other children in the orphanage.  The children, in 
turn, looked up to all the staff as aunts and uncles.  It was an arrangement that offered love and security 
for all those in FNX. </p>
<p style="text-indent: 50px">
“Our director is on her way.”  Allyson told Adam.  She held her hand to the sofas.  “Please have a seat 
while you wait.  I don't have authority to let you in the garden, but she does.”  Adam nodded and took a 
breath.  This was his chance to escape if he chose to take it.  He wouldn’t get to see Aurorah today, but 
at least he knew what he was up against when it came to FNX.  On the other hand, this was an opportunity to 
see the inside of FNX and meet Director Jasminy.  He’d be lying if he said he wasn't curious about her. </p>
<p style="text-indent: 50px">
“Alright.”  Adam huffed out, cautiously taking a seat on the sofa.  He had nothing else to do today.  Why 
not spend the day exploring someplace new?  It was reminiscent of meeting the parents of the girl he liked.  
Adam glanced down at his clothes, wishing he had chosen a button up instead of the graphic tee he was wearing.  
Rapunzel handed him the bouquet of flowers after he was seated and retreated to her perch in the doorway.  
Silence fell in the lobby.  Adam patted his knees as he watched Allyson type away at her computer.  Rapunzel 
didn't say anything as she stared at him from the entrance to the hallway.  It was awkward, and Adam started 
to sweat. </p>
<p style="text-indent: 50px">
“Hello.”  Greeted a tall woman with raven black hair.  Adam sprang from his seat on impulse.  Was this the 
director, he wondered.  He ruled that out immediately.  “Welcome to the Fenix Monastery.  I heard we had a 
guest, so I came out to see who the brave soul was that dared to step foot in our sacred space.”  The woman 
said, walking over and leaning against the front desk.  There was no playfulness in her actions.  Adam froze 
as her eyes roved over him.  “What’s your name, stranger?”  Her tone was sharp, and Adam could feel the 
tension rise around them.  This was the infamous Katia Volkov. </p>
<p style="text-indent: 50px">
“Hello.”  Adam answered, nodding his head.  Under such a threat, Adam fell back into his military routine.  
“The name is Adam Borealis, ma’am.”  He said with confidence.  Now the flowers in his hands felt awkward.  
He glanced down at the arrangement before returning his attention to Katia.  “I just…”  He played with the 
bouquet.  He just what?  Adam didn't record that he was here for Aurorah.  He had no idea if she even 
considered him a friend or not! </p>
<p style="text-indent: 50px">
“Those are for Aurorah?”  Katia asked, jumping straight to the point.  She suffered no fools.  “Are they for 
her birthday, then?” Katia wanted to speed the conversation along.  She was relieved it wasn’t a loser gym 
rat coming to pick on one of the kids again.  The guest also wasn’t another waiter sniffing around the girls’ 
skirts.  Katia had enough of the sneaky boys from Eat Your Everything restaurant coming to see their orphan 
girls. </p>
<p style="text-indent: 50px">
Adam tensed at her statement.  Images of Aurorah at the bar, rubbing her forehead and looking frustrated, 
flashed in his mind.  She was there to celebrate her birthday, Adam realized.  That’s why he had never seen 
her before!  From how she acted, Adam could tell bars were not Aurorah’s thing.  If he did get to see her 
today, he wanted to invite her to coffee or tea.  He prayed she would enjoy that more than a loud, rowdy bar 
where everyone whispered about her and FNX.  Katia let out a loud sigh. </p>
<p style="text-indent: 50px">
“You didn’t know it was her birthday.”  Katia deduced.  She shrugged her shoulders.  It didn’t matter to 
her.  She was here to make sure this strange man didn't hurt her sweet nieces.  Now that she knew he wasn't a 
troublemaker, Katia walked over to the sofa across from the one Adam sat at.  Her black leather high heel 
boots clicked on the tile as she walked.  Adam was both intrigued and scared by her.  “Please have a seat.”  
Katia said, plopping down and crossing one knee over the other.  “Jas will be here in a moment.  My name is 
Katia.”  She threw her arms over the back of the sofa and relaxed.  “Nice to meet you.”  Adam took a breath.  
The deep amethyst blouse that Katia wore didn't hide the incredible tone of her arms and shoulders.  She had 
a lean fighter’s body.  Adam was a confident fighter, but he doubted his chances against Katia.  If he had 
to face her in the underground arena, it was anyone's guess who would emerge victorious. </p>
<p style="text-indent: 50px">
“Nice to meet you.”  Adam responded.  He shook his head, freeing himself from his daydream of fighting Katia 
in the underground arena.  He held up the flowers.  “This is just an inside joke.”  He offered to justify his 
presence.  Adam had to remind himself of that over and over.  He decided to stick it out and see his 
enchanting ice queen, so he had to survive until he could hand her the bouquet. </p>
<p style="text-indent: 50px">
“ALLYSON!”  Came a shout from the hall.  Adam nearly flinched.  Katia was unphased.  This was the normal 
everyday life for FNX.  Rapunzel covered her mouth as a storm of giggles erupted from her. </p>
<p style="text-indent: 50px">
“What!?”  Allyson slid back in her chair and held her hands up.  Adam spied a devilish smile on her face 
before a woman with bouncy brown hair came rushing from the hall.  “I’m just answering Uncle Edric’s 
question!  He was curious!” </p>
<p style="text-indent: 50px">
“Stay off the FNX chat!  You are supposed to be managing the front!  You can’t do that if you continue to 
gossip with your sisters!”  The woman snapped.  “If Edric wants to ask you something, he can walk his ass 
here and ask you here!”  She pointed at the ground to emphasize her point.  Allyson sighed and rolled back to 
the desk. </p>
<p style="text-indent: 50px">
“Fine!”  Allyson huffed, puffing out her cheeks.  She clicked around with the mouse before turning around.  
“There.  I closed it.”  Adam almost laughed at the scene unfolding in front of him.  It was adorable and 
completely unexpected.  This was the director of FNX, Adam mused.  She wore a champagne-colored power suit 
with chocolate stilettos.  There was no confusing her for anyone but Director Jasminy Angeles. </p>
<p style="text-indent: 50px">
“Do not get sassy with me, or I will take your cookies away!”  Jasminy groaned, grabbing the bridge of her 
nose.  It was already a long day.  She was swamped with work, and now there was an unexpected visitor.  At 
least it wasn’t one of the members of Deadlift N’ Abs.  She was tired of the constant emails and complaints 
from them.  Jasminy had a budget that still needed approval, several patients just admitted into the 
infirmary that likely participated in the underground arena, and report cards for the orphans to review.  Her 
patience for Allyson’s shenanigans was dried up. </p>
<p style="text-indent: 50px">
“It’s alright, Jas.”  Katia said, bouncing her foot.  “I’m here for support.” </p>
<p style="text-indent: 50px">
“It’s not you I’m worried about.”  Jasminy mumbled.  After taking a breath, she faced the man sitting across 
from Katia.  Holding a hand to her chest, she introduced herself in her practiced, formal manner that she 
used for business.  “Greetings.  I am Jasminy, Director of the Fenix Monastery.”  She glanced at the flowers 
in his hand.  “I was informed you were here to see Aurorah… Is that right?” </p>
<p style="text-indent: 50px">
Rapunzel glanced at Allyson as the grownups were talking.  Allyson bit her bottom lip and waved Rapunzel 
over.  The chat was open on the computer monitor.  Allyson sneakily pointed to the screen while keeping her 
eyes fixed on Jasminy.  Rapunzel snuck over and took a peek. </p>
<p style="text-indent: 50px"><i>
YunnaKitty:  He sounds dreamy!  Tell us more, Ally! </p>
<p style="text-indent: 50px">
MorDragonSlayer:  Has anyone messaged Aunt Aurorah about him being here? XD </p>
<p style="text-indent: 50px">
BeaBopQueen:  I don’t think so.  She is still in the garden with Eloain and Medusa. </p>
<p style="text-indent: 50px">
CealingFan:  Who are we talking about again?  Someone is here? </p>
<p style="text-indent: 50px">
MorDragonSlayer:  I’m almost done at the infirmary.  Some bozos started a fight and got hurt 
pretty bad.  Uncle Edric is writing them a prescription now. </p>
<p style="text-indent: 50px">
BeaBopQueen:  Oooo!  Who won would you say? </p>
<p style="text-indent: 50px">
YunnaKitty:  We are talking about the man that came to see Aunt Aurorah, Cealen! </p>
<p style="text-indent: 50px">
MorDragonSlayer:  No one! Lol they are all trashed. </p>
<p style="text-indent: 50px">
CealingFan:  Does that mean Aunt Aurorah has a boyfriend? </p>
<p style="text-indent: 50px">
YunnaKitty:  I think so! *heart*  Ally’s been telling us about him.  He’s in the lobby. </p>
<p style="text-indent: 50px">
BeaBopQueen: XD  Hilarious!  Must be the losers from the arena then. </p></i>
<p style="text-indent: 50px">
Allyson glanced at Rapunzel.  They giggled quietly, enjoying the chat, before Allyson quickly closed the 
window.  Jasminy was finishing the elevator speech about FNX and was gesturing to the hallway.  That was 
Allyson’s cue.  Jasminy was going to take Adam to the garden to see Aurorah.  Whatever exchange they had 
while Allyson was chatting had earned Adam the privilege of entering FNX.  No way was Allyson missing all 
the excitement.  She picked up her phone and nodded to Rapunzel.  Rapunzel nodded back, fishing her phone 
out of her denim jumper.  The younger teenager wasn’t as active a chatter on the FNX chat, but she never 
missed a thing.  The chat was too spicy to ignore!  Rapunzel opened up the app that Edric installed and gave 
everyone the update. </p>
<p style="text-indent: 50px"><i>
RosiePrincess:  Hey, everyone!  Mother is taking Mr. Borealis to see Aurorah now! </p>
<p style="text-indent: 50px">
DarkAlly:  Switching to my phone.  Aunt Katia is going to man the front desk. </p>
<p style="text-indent: 50px">
YunnaKitty:  I want to meet him too! </p>
<p style="text-indent: 50px">
MorDragonSlayer:  No, Yunna!  You need to stay in bed and get better. </p>
<p style="text-indent: 50px">
YunnaKitty:  >__< </p>
<p style="text-indent: 50px">
BeaBopQueen: Father Zeph stepped out, so Ceal and I will being spying from the chapel. </p>
<p style="text-indent: 50px">
MorDragonSlayer:  Again? </p>
<p style="text-indent: 50px">
CealingFan:  Yeah.  We can’t do much without him here to direct us. </p>
<p style="text-indent: 50px">
DarkAlly:  I wonder if that means Caleb will show up! HA HA HA </p> </i>
<p style="text-indent: 50px">
“Allyson!”  Jasminy snapped.  Allyson stuffed her phone in her pocket as her heart skipped a beat.  Rapunzel 
snickered next to her.  “I want you to stay here.”  Jasminy stated firmly.  Allyson’s expression fell. </p>
<p style="text-indent: 50px">
“What!?”  Allyson whined.  She glanced at Adam with a pleading look.  “But I-,” </p>
<p style="text-indent: 50px">
“Don’t worry, Jas.”  Katia said, standing up.  She moseyed over to the front desk, patting Allyson on the 
shoulder.  “The girls shouldn't be alone here anyway.  I’ll watch the front while you escort our guest.”  
She smiled at Allyson.  “Allyson and Rapunzel should go with you.”  Jasminy glared at Katia.  She could read 
between the lines.  Katia wanted the girls to report back to her what happened in the garden.  The Russian 
beauty was just as susceptible to gossip and drama as the girls were.  It was a terrible influence! </p>
<p style="text-indent: 50px">
Meanwhile in the garden, completely unaware of all the chatter and excitement, Aurorah was helping bathe 
the pets of FNX with Medusa and Eloain.  Eloain Everbloom was the official kennel master of FNX, in charge 
of managing the shelter, and took care of all the pets living in FNX.  She adored animals and had a gentle 
nature that suited the role.  The three ladies had a kid-sized pool to bathe all the canines.  The cats 
required a more cautious approach, but that would be later. </p>
<p style="text-indent: 50px">
Eloain giggled as the female German Shepard she was washing shook water everywhere.  “Easy, Carla!”  Eloain 
laughed.  “You aren’t quite done yet!”  Her musical laughter made Aurorah and Medusa laugh as well. </p>
<p style="text-indent: 50px">
“You are almost done.  Thank you for being such a good girl, Siri.”  Aurorah cooed to the Golden Retriever 
she was bathing.  She kissed the dog’s warm wet nose, and Siri licked Aurorah’s face in return.  This was one 
of her favorite responsibilities in FNX.  Technically speaking, Aurorah worked with Jasminy, managing public 
relations of the monastery with the rest of FNX.  She oversaw outreach programs and community events that 
helped educate the community on services that FNX offered.  Her work was meaningful, and she took great pride 
in it. </p>
<p style="text-indent: 50px">
“AHH!  STOP!”  Medusa squealed, shielding her face from the spray of bubbly water.  “HEX!  Bad doggie!”  She 
lectured the lively male Doberman Pinscher who was splashing around in the pool.  “Settle down, you big 
goofball!”  The animal was nearly as large as she was and had twice the strength in his muscular body.  The 
other male Doberman, Pine, lazily lounged in the pool, resting his head against the inflatable side.  He 
growled playfully and snorted in amusement at all the attention they were getting today.  Aurorah giggled as 
she brushed back some of her hair behind her ear.  The big pet race was coming up, and these were a few of 
the top competitors FNX registered for the event.  </p>
<p style="text-indent: 50px">
“Who do you think is going to win this year?”  Aurorah asked Eloain with an elbow nudge as they both scrubbed 
down the dogs.  “Maybe we should enter Dolly this year?”  Aurorah questioned, glancing at the young Cocker 
Spaniel patiently waiting for her turn in the pool. Eloain smiled and nodded in response. </p>
<p style="text-indent: 50px">
“I don't know.  The <i>Hard ROCS</i> always have the top show dogs,”  Eloain responded with a shrug of her 
shoulders.  When it came to the <i>Hard ROCS</i> competing in Niveal-wide events, they had enough wealth to 
buy first place.  Sugar Apimentada, owner of the <i>Hard ROCS</i>, always spent however much money necessary 
to ensure her brand was well-represented in the eyes of the community.  Their pets had top-of-the-line care, 
special training, and even their own private groomer ensuring they always looked their best when 
participating in community events.  Eloain pushed the thoughts aside for now.  FNX didn't participate in 
events solely to win, unlike Sugar and her crew.  They participated to have fun and showcase the beautiful 
animals up for adoption. </p>
<p style="text-indent: 50px">
“I agree though.  Dolly is old enough to enter now.”  Eloain reached her hand over and petted the Cocker 
Spaniel on the head.  The dog whined for more and crawled over to Eloain, forcing her snout into Eloain’s 
lap.  “Ahh, do you want some more loving?  You’re so spoiled,”  Eloain muttered to the dog as she played with 
Dolly’s big, floppy ears. </p>
<p style="text-indent: 50px">
“Excellent,”  Aurorah smiled at Eloain,  “I have the proposed budget for the event already submitted to 
Jas.  I budgeted enough for every pet eligible to race, so they will have a spot whether they are able to 
participate or not.”  Aurorah rinsed off Siri and started to pat her dry.  “Isn’t that right, Siri?  Everyone 
should have the opportunity to race if they want to.” </p>
<p style="text-indent: 50px">
“Hopefully,” Medusa groaned, wrestling to wash Hex,  “someone comes to adopt them after seeing how well they 
do… If they do well.”  Hex stopped struggling with Medusa and stood straight with his ears turned.  Pine sat 
up and lifted his head too.  Aurorah, Medusa, and Eloain all looked in the direction that the two male dogs 
were staring. </p>
<p style="text-indent: 50px">
“Oh shit!”  Medusa muttered.  “Stay!”  She commanded.  Aurorah and Eloain sighed and shook their heads 
knowing full well  Medusa was in for it.  Across the garden, bounding out of the kennel, was Bell, a female 
Doberman and playmate for Pine and Hex.  When Bell saw Pine and Hex, she dropped her front legs in a playful 
stance, wagging her short, stumpy tail.  Bell was inviting the boys to chase her. </p>
<p style="text-indent: 50px">
“Well…”  Aurorah said, drying off Siri.  “Those two will have to be washed again after this.” </p>
<p style="text-indent: 50px">
“NO!”  Medusa yelled as she tried to stop Hex from accepting Bell’s invite.  Pine spared no time in hopping 
out of the pool and running after her.  The commotion stirred Hex into a frenzy.  He wasn't being left out!  
Medusa fell face-first into the pool as Hex shook free and took off.  Aurorah and Eloain laughed. </p>
<p style="text-indent: 50px">
“Here, let me help you.”  Aurorah said, offering her hand to Medusa.  Medusa gladly accepted the help.  She 
was exhausted from wrestling that Goliath canine. </p>
<p style="text-indent: 50px">
“Thanks,”  sighed Medusa.  She walked over to the lawn chairs Eloain had set up for them.  There were iced 
lemonades in the cupholders for each of them.  Washing, feeding, and caring for the pets was tough work, and 
Eloain wanted to make sure all the FNX staff who helped out felt her appreciation.  “Maybe I’ll just chase 
them with the hose later.  They are short hairs anyway,”  Medusa moaned, walking over and sitting in a lawn 
chair.  “They don't have to be washed and brushed like the others.” Aurorah laughed.  Today was going great 
so far. </p>
<p style="text-indent: 50px">
The banquet Medusa held for Aurorah’s birthday was fantastic.  It was held in the main dining hall of FNX.  
Everyone showed up, wishing her the best and showering her with birthday wishes.  It was all her favorite 
people, hanging out and having a great Friday night.  When she went for her morning run this morning, with 
her German Shepherd Egg Roll, her thoughts kept circling back to her encounter with Adam.  His persistent 
banter brought a smile to her face as she recalled the way he smirked at her.  She wondered if she would 
ever see him again. </p>
<p style="text-indent: 50px">
Aurorah pulled out her phone and glanced at the notifications.  There were no new emails from the city 
planner about the baking event FNX wanted to host.  It was a baking event that would be held in the town 
square, allowing everyone in the kingdom to try their hand at baking bread and cake.  Medusa worked with 
Aurorah in public relations and recently purchased thousands of dollars of wheat from the local farmers.  
It was to keep them afloat when demand dropped.  FNX would use the wheat they could and then hold festivals 
and events to use the rest of it.  The Battle of the Bakers was one event that Aurorah loved to host.  
Along with supervising the event, Aurorah would brew tea and coffee to accompany all the desserts and bread 
being made.  The event always drew a crowd and gave FNX a popularity boost. </p>
<p style="text-indent: 50px">
“What?”  Aurorah furrowed her brows as she scrolled through her other notifications.  There were sixty-four 
new messages on the FNX chat in just the last hour. Aurorah laughed and rolled her eyes.  Something juicy 
was going on, and she was tempted to open the app and check. </p>
<p style="text-indent: 50px">
“What?”  Medusa asked, sipping on her glass of lemonade. “Did the city planner respond to our request 
yet?”  She leaned back and threw an arm over her eyes.  “I mean, we know it will be approved, so it’s just a 
formality at this point.” </p>
<p style="text-indent: 50px">
“No,”  laughed Aurorah while stuffing her phone back in her pocket.  Since she was taking care of the 
animals today, Aurorah came to work dressed very casually with denim short shorts and a pale blue tank top.  
“The FNX chat is blowing up.  Father Zephyr must have gone out for cigarettes again,”  she laughed, 
prompting Eloain and Medusa to laugh with her.  It was the running joke of FNX. </p>
<p style="text-indent: 50px">
Father Zephyr Biscate was the head priest for the chapel.  He led services and managed community outreach 
programs, yet he was also a huge flirt.  Constantly, he called Jasminy his sweetheart and angel.  At the 
same time, Father Zephyr would bat his eyes at Katia and Aurorah.  Aurorah knew it wasn’t serious.  She 
didn’t indulge him or his antics, making her surrounding boundaries very clear.  After a very nasty black 
eye from Katia, Father Zephyr focused all his flirtation on Jasminy.  His romantic hooks had found an anchor 
with Jasminy, and all of FNX enjoyed the banter between the two.  They fought like an old married couple, 
flirted with each other like love sick teenagers, and somehow managed to excel at their respective work all 
at the same time.  Most of the time, the FNX chat was filled with Jasminy and Zephyr going back and forth. </p>
<p style="text-indent: 50px">
“Oh my!”  Eloain laughed.  After she finished drying off Carla, Eloain pulled out her phone.  Medusa set her 
lemonade back down in her cupholder and whipped out her phone.  No way were they missing the drama!  
“Let’s see what has everyone fired up,”  Eloain mused, opening the app. </p>
<p style="text-indent: 50px">
Aurorah shook her head. She didn't care. Aurorah stretched and placed her hands on her hips, looking around 
the garden for the next dog in need of a bath.  The garden was located at the center of the monastery with 
stone walkways to the shelter along with flower beds and vegetable beds.  Now that it was summer, the scent 
of flowers and fresh-cut grass wafted in the air.  Aurorah felt at peace here.  It was a beautiful day, and 
nothing could ruin her mood. </p>
<p style="text-indent: 50px">
“What!?”  Medusa gasped, sitting up,  “Aurorah, girl!”  Aurorah snapped out of her thoughts and glanced over 
at her friend.  Eloain was covering her mouth and staring at Aurorah with a cherry-red face. </p>
<p style="text-indent: 50px">
“What?”  Aurorah asked.  Her whole body tensed.  She hadn't done anything to stir such a fuss from FNX.  It 
was too early in the day!  Eloain giggled, patting Dolly on the head.  </p>
<p style="text-indent: 50px">
“We have a guest!”  Eloain said.  Her eyes sparkled with mischief.  Medusa, on the other hand, looked 
panicked. </p>
<p style="text-indent: 50px">
“Yeah, and he is here to see you!”  Medusa said, scrolling on the chat to get to the beginning.  As she read 
the description of the man visiting, her face drained of color upon the familiarity of it all.  “What was 
that stooge’s name at the bar?” Medusa demanded, “Sounds like that bum based on Allyson’s description.” 
Aurorah’s heart skipped a beat.  It couldn't be.  She never told Adam about her work, not by name anyway.  
He couldn't be here to see her.  Eloain glanced from Medusa to Aurorah. </p>
<p style="text-indent: 50px">
“Did you meet someone?”  asked Eloain.  The giddiness in her voice made Aurorah scowl at her.  Aurorah 
didn’t meet anyone in that sense.  She just… Well, what did she think about her encounter?  It wasn’t 
terrible, Aurorah could admit, but it wasn't the romantic affair Eloain was thinking of.  A shudder of fear 
rocked her.  After leaving the bar, Medusa and Aurorah came to FNX for the banquet.  A million questions 
raced through her head. Had Adam followed her?  That would be creepy! </p>
<p style="text-indent: 50px">
“It wasn’t anything serious,”  Aurorah waved her hands innocently.  Before Eloain could respond, all the 
dogs turned their heads toward the main office building.  That was where the front lobby was and where the 
guest would be.  Aurorah took a breath.  She was caught off guard, but she could comport herself properly 
nonetheless.  Aurorah was a lady above all else. </p>
<p style="text-indent: 50px">
“This is the garden.  Careful, the pets are getting a bath,”  Jasminy explained.  She opened the gate 
surrounding the garden.  Allyson and Rapunzel walked in, holding their arms out to block the dogs from 
jumping on Adam. Immediately, Bell, Pine, and Hex bounded up to the girls with their tongues out. </p>
<p style="text-indent: 50px">
“Pine!  Easy!”  Allyson shouted as the dog lifted his front legs and clobbered Allyson.  Rapunzel squealed 
as Hex and Bell licked at her face. “Down!” Allyson commanded as Adam laughed. He loved animals, especially 
Dobermans.  He presented his hand for them to smell. </p>
<p style="text-indent: 50px">
“They are beautiful!”  Adam stated as Bell sniffed at his hand, “You can tell they are well cared for.” 
Adam glanced at Jasminy,  “How many shelter animals do you house?  Do you get any support from the city?”  
Jasminy sighed and tilted her head back and forth.  She was judging how much to share with Adam.  So far, 
he was making a decent impression.  He was polite to all of them, the children weren’t afraid of him, and 
Katia didn’t kick him in the balls.  It was her job to protect FNX and everyone that lived and worked here.  
If she opened up to Adam, she had to consider the risks. </p>
<p style="text-indent: 50px">
“That is more of Aurorah’s department,”  Jasminy answered with a smile.  She held her hand to Aurorah, who 
was standing out of ear shot. For now, Jasminy would defer the decision to Aurorah.  This was her friend, 
after all.  “She manages business with the city and mayor.” Adam followed where Jasminy directed and took 
in a breath.  There she was! </p>
<p style="text-indent: 50px">
Adam drank in the sight of Aurorah in mini shorts.  She had legs for days that rendered him speechless.  
Even when Bell started to lick his hand, Adam couldn't look away from her.  All his courage he had built up 
to come and see her evaporated. This moment was too overwhelming for him.  His plan of stopping by for a 
quick visit turned into Adam being swallowed by FNX. </p>
<p style="text-indent: 50px">
Allyson and Rapunzel giggled together as they watched Adam stare at Aurorah.  His cheeks brightened to a 
rosy color as she started walking towards them with Medusa following close behind.  Allyson whipped out her 
phone and started to text updates to the group. Rapunzel stood next to her and glanced over Allyson’s 
shoulder. </p>
<p style="text-indent: 50px">
“Adam?”  Aurorah asked when she got close enough.	 She took a breath and let it out slowly.  She was only 
nervous because he was here in the monastery.  That was all.  The fluttering in her stomach when she looked 
at the flowers was because it was almost lunchtime.  That was all.  “I didn’t expect to see you here,” 
remarked Aurorah, folding her arms.  Her gaze kept jumping from the flowers to Adam.  “Are you here to kill 
me then?” </p>
<p style="text-indent: 50px">
All eyes swung to Adam, making him flinch.  Allyson stopped texting as she and Rapunzel stared at him.  
Whatever transpired here, between him and Aurorah, would be shared with the entire monastery!  No pressure, 
Adam mused. He laughed nervously and held the flowers to her. </p>
<p style="text-indent: 50px">
“I told you I knew what to write on the card now,”  Adam explained,  “These are for you.  I… I didn't 
realize it was your birthday yesterday.  Happy belated birthday, Aurorah.”  He waited as they all stared 
at him.  Adam had been to several of the clubs around Niveal, where he was surrounded by women.  He served 
shoulder-to-shoulder with many strong and intimidating women.  Despite that, these ladies made him nervous.  
Time stood still, and Adam held his breath. </p>
<p style="text-indent: 50px">
“Thank you,” Aurorah answered, breaking the silence.  She accepted the flowers and nodded at Adam.  She 
loved the selection, and it would be terrible for them to go to waste.  It just so happened, Aurorah told 
herself, that she had an empty vase in her office.  Her icy blue eyes fixed on Adam.  “How did you know it 
was my birthday?  Are you stalking me?” </p>
<p style="text-indent: 50px">
Medusa and Jasminy both shifted on their feet.  Adam tensed from the accusation.  This was the sharp-tongued 
ice queen.  What else was he expecting?  Allyson’s hands flew over the keys of her phone.  Rapunzel pulled 
out her phone and joined in.  Adam had to get out of there!  Now that he was able to see Aurorah and deliver 
the flowers, he had to escape! </p>
<p style="text-indent: 50px">
“No, no!”  Adam said, waving his hands innocently.  He backed up until he was past the gate to the garden.  
Jasminy was fierce in her own right, but Katia stayed at the front desk.  To escape, he had to make it past 
her.  “After you left, Deamok mentioned you worked at the Fenix Monastery,”  he shrugged his shoulders as 
Jasminy stood straighter.  “That was all.  I always thought this place looked cool, so I decided to stop 
by,” he rambled on.  He was too focused on Aurorah to notice the teenagers gasp at his statement. </p>
<p style="text-indent: 50px">
“Is that right?”  Jasminy asked, folding her arms.  She instantly snapped to full mother bear mode.  Nobody 
messed with her FNX family!  “The employees of <i>Hard ROCS</i> were gossiping about us again? Am I 
understanding you right?”  Jasminy glanced at Aurorah and Medusa, “Did they bother you last night?  Did 
they say anything to you?” </p>
<p style="text-indent: 50px">
“No, no!”  Medusa answered, waving her hands.  “We had a great time.  Nobody started any trouble.”  Medusa 
couldn't resist the sly smile slowly spreading across her face.  She was afraid Aurorah didn’t enjoy 
herself, but the blushing Icelandic princess was hiding her smile behind the flowers.  “We BOTH had a great 
time.”  She nudged Aurorah. </p>
<p style="text-indent: 50px">
Allyson’s fingers flew over the keys of her phone.  She rocked with quiet laughter as Rapunzel did the 
same.  Adam swallowed back some of his mounting panic as Jasminy returned her gaze to him.  It was as if 
she could extract the truth from him with those impenetrable bronze eyes.  Jasminy didn’t answer questions, 
she asked them! </p>
<p style="text-indent: 50px">
“So, what did Deamok say?”  Jasminy asked. “Sugar and I communicate regularly.  If her employees are 
bad-mouthing mine, we will have a chat.” </p>
<p style="text-indent: 50px">
“Oh, it was nothing like that,” Adam responded, waving down her aggressive stance. After all, he hadn’t come 
here to start a problem.  He glanced back at his actual reason, Aurorah.  Adam wanted to meet her at her 
level.  If she was saucy, then he would dish it right back.  “Deamok was just thrilled that the FNX ladies 
didn’t start any trouble.” </p>
<p style="text-indent: 50px">
“I’m a troublemaker?”  Aurorah asked, holding the flowers away from her face.  She glanced at Medusa, 
“Medusa I can believe, but not me!” </p>
<p style="text-indent: 50px">
“Your trouble for my heart.  Does that count?”  Adam responded.  He was back at the bar, trading quips with 
her again.  Aurorah stifled a laugh. </p>
<p style="text-indent: 50px">
“There is an infirmary located in that building,”  Aurorah pointed.  “You should have our doctor check you 
out if you are having heart problems,” she answered without missing a beat.  Adam laughed, feeling a bit 
more relaxed. This was nice.  He couldn't remember the last time he laughed like this. </p>
<p style="text-indent: 50px">
“Is the doctor as cute as you?”  Adam asked playfully.  All the women laughed. </p>
<p style="text-indent: 50px">
“Our doctor is a man!”  Jasminy laughed, stowing away her armor for now.  She was still going to reach out 
to Sugar about the gossiping bartender, but Adam turned out to be surprisingly nice.  “He is my brother!” </p>
<p style="text-indent: 50px">
“Then, I’m good, thanks,” Adam chuckled. </p>
<p style="text-indent: 50px">
“Oh!”  Allyson gasped and glanced at Jas.  She stowed her phone and brushed some hair behind her ear.  
“Well… I should really be getting back to the front.  Aunt Katia probably has more important things to do.”  
She exchanged a grin with Rapunzel and left the garden. </p>
<p style="text-indent: 50px">
“Allyson!”  Jasminy hollered, clapping her hands to get the girls' attention.  “Don’t lie to your mother.  
Where are you really going?”  Aurorah and Medusa snickered. </p>
<p style="text-indent: 50px">
“To the front!  I’m not lying,” Allyson responded.  Adam raised an eyebrow at her.  She wasn't lying, but 
she wasn't sharing everything.  Jasminy hummed with suspicion before she pulled out her phone and checked 
the FNX chat.  There were over a hundred and forty notifications.  Allyson and Rapunzel waved goodbye to 
Adam and Aurorah. </p>
<p style="text-indent: 50px">
“It was nice meeting you, Mr. Borealis,”  Rapunzel said shyly,  “I hope you come visit again.” </p>
<p style="text-indent: 50px">
“Bye, Mr. Borealis, Aunt Aurorah,”  Allyson said, pulling Rapunzel in the direction of the main office.  
“Make sure to schedule your next visit at the front desk before you leave!”  She hollered over her shoulder. </p>
<p style="text-indent: 50px">
“ALLYSON!”  Jasminy yelled, looking up from her phone.  She muttered swears in Portuguese as rubbed her 
forehead. </p>
<p style="text-indent: 50px">
“What is it?”  Medusa asked, walking over to Jasminy and poking her in the arm.  “Is Caleb taking the girls for 
ice cream again?”  Aurorah couldn't resist a laugh.  Sweets were the only driver for Allyson.  She was old 
enough to officially work, and FNX did pay her and Moraine to work the front desk.  If they could get away 
with it, Aurorah knew Allyson would accept her pay in the form of desserts. </p>
<p style="text-indent: 50px">
“He always comes at the wrong time!”  Jasminy groaned.  Caleb Monarca was the FNX financial manager.  He was 
late, and Jasminy was irritated.  He was supposed to be here over an hour ago, so they could review the 
budget for the quarter including the pet races budget that Aurorah submitted.  “Of course, he shows up right 
as I am attending to a guest,”  Jasminy bemoaned. </p>
<p style="text-indent: 50px">
“Send Zephyr away sooner next time,”  Medusa laughed as she held her hand out, gesturing for Adam to 
enter.  Aurorah stepped aside, welcoming Adam to join them.  Since he was here and since he was dressed 
casually, they could use the help with washing the pets.  “Come on, Mr. Borealis, join us,”  she said, 
grinning at Jasminy,  “Jas seems to have her hands full, what with all her love interests.”  Aurorah 
snickered as Jasminy stormed off after the girls, and Adam hesitantly entered the garden again. </p>
<p style="text-indent: 50px">
As Medusa was explaining about the animal shelter and introducing Eloain, Aurorah pulled out her phone to 
catch up on the drama. </p>
<p style="text-indent: 50px"><i>
Kratos:  He isn’t here to see my Jas, is he? </p>
<p style="text-indent: 50px">
YunnaKitty:  It’s Aunt Aurorah’s new boyfriend! </p>
<p style="text-indent: 50px">
DarkAlly:  No, no!  He is here for Aunt Aurorah. </p>
<p style="text-indent: 50px">
CealingFan:  They are talking in the garden.  Aunt Aurorah is smiling! </p>
<p style="text-indent: 50px">
Kratos: *phew* Well if she is busy, we can work on the budget later. </p>
<p style="text-indent: 50px">
FrontDesk:  They should be washing the pets.  The pet races are coming up. </p>
<p style="text-indent: 50px">
DarkAlly:  Aurorah loves the flowers!  I guess she met him yesterday at Hard ROCS </p>
<p style="text-indent: 50px">
BeaBopQueen:  Were those assholes talking shit again? </p>
<p style="text-indent: 50px">
RosiePrincess:  Mr. Borealis said no, but I know Mother will still check with Sugar. </p>
<p style="text-indent: 50px">
MorDragonSlayer:  What did they say?  Was it Aurelie? </p>
<p style="text-indent: 50px">
DarkAlly:  I don't know… Some guy he called Deamok. </p>
<p style="text-indent: 50px">
Kratos:  That’s the bartender.  I wouldn't worry about it, girls.  Anyone want ice cream? </p>
<p style="text-indent: 50px">
DarkAlly:  I do! </p>
<p style="text-indent: 50px">
YunnaKitty: MEEEEE I WANT ICE CREEAAAMMM! <p>
<p style="text-indent: 50px">
CealingFan:  Father Zephyr isn’t back yet.  Can Beatrice and I come too? </p>
<p style="text-indent: 50px">
RosiePrincess:  I want ice cream too! </P>
<p style="text-indent: 50px">
Kratos:  Great!  I’ll be in the lobby.  I’m leaving in 5 mins with whoever is here. </p></i>
<p style="text-indent: 50px">
“AHHH!”  Aurorah squealed when she was blasted by the hose.  Medusa, Eloain, and Adam were all laughing. </p>
<p style="text-indent: 50px">
“Stop ignoring your duties and help us!”  Medusa shouted to her.  Aurorah took a deep breath and stuffed 
her phone back in her pocket.  She would pay Medusa back for that.  After setting down the flowers in her 
lawn chair to protect them from the dogs, Aurorah got back to work.  She shoved Medusa in the pool as Dolly 
and Nocte jumped in with her.  She wasn’t expecting to see Adam today, but it was a pleasant experience.
</p>`,
          isAvailable: true,
        },
        {
          id: 'chapter-3',
          chapterNumber: 3,
          title: 'Down in the Dungeon',
          content: '<p>The sun rose over the mountains...</p>',
          isAvailable: false, // This chapter is not yet released
        },
        // Add more chapters here as they are released
      ],
      isMenuVisible: false, // Start with the mobile menu hidden
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
    handleResize() {
      // Show the menu by default on large screens
      this.isMenuVisible = window.innerWidth > 768;
    },
    scrollToChapter(chapterId) {
      const element = document.getElementById(chapterId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        // Close the menu after clicking a link
        if (window.innerWidth <= 768) {
          this.isMenuVisible = false;
        }
      }
    },
    /*rateChapter(chapterId, rating) {
      console.log(`User rated chapter ${chapterId} with a ${rating}.`);
    },*/
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // Call it once on mount to set initial state
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped>

.story-page {
  max-width: 800px;
  margin: 0 auto;
  font-family: 'Georgia', serif;
}

.story-header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
  padding: 10px 0;
  border-bottom: 1px solid #ccc;
}
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 800px;
  margin: 0 auto;
}
/* Base styles for navigation (desktop-first approach) */
.chapter-navigation {
  display: block; /* By default, show navigation */
  margin-top: 10px;
}
.quick-links {
  list-style-type: none;
  padding: 10;
  flex-wrap: wrap;
  gap: 15px;
  text-align: center;
}

.quick-links li {
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  padding: 10px;
}

.quick-links a {
  text-decoration: none;
  color: #007bff;
  font-weight: bold;
}

.disabled-link a {
  color: #888;
  pointer-events: none;
}

.rating-buttons {
  display: flex;
  gap: 2px;
}

.thumbs-up, .thumbs-down {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0;
}

.story-content {
  margin-top: 20px;
}

.chapter-section {
  margin-bottom: 40px;
}

.chapter-text {
  text-align: justify;
  line-height: 1.6;
  font-size: 1.1rem;
}
.chapter-text p {
    text-indent: 4em;
    padding: 0;
    margin-bottom: 0em
}
.toprow{
  display: flex;
  align-items: center;
  text-align: left;
  max-height:190px;
  background-color: #d6d6c2;
}
h1 {
  display: flex;
  font-size:40px;
  padding:10px 10px;
  max-height:90px;
}
.toprow img {
  display: flex;
  width: 87px;
  height:107px;
}
.welcome p {
    padding: 5px;
    line-height: 1.6;
    text-align: justify;
}


.hamburger-button, .close-button {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  display: none; /* Hide by default on large screens */
}

@media (max-width: 768px) {
  .header-container {
    flex-direction: column;
  }

  .hamburger-button {
    display: block; /* Show hamburger button */
  }
  
  /* Hide the full navigation menu initially on mobile */
  .chapter-navigation {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    width: 250px;
    height: 100%;
    background: #f8f9fa;
    padding: 20px;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
    z-index: 20;
    flex-direction: column;
    align-items: flex-start;
  }

  /* When 'isMenuVisible' is true, show the mobile menu with a slide-in animation */
  .chapter-navigation.mobile-nav-visible {
    display: flex; /* Override display: none */
    animation: slideIn 0.3s forwards;
  }

  .quick-links {
    flex-direction: column;
    gap: 10px;
  }

  /* Show the close button on mobile */
  .close-button {
    display: block;
    align-self: flex-end; /* Align the close button to the top-right */
  }

  /* Optional: Animation for the slide-in menu */
  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

}
</style>